import Base from '../Pages/Base'
import ListCategoriasControleInterno from '../Pages/Categorias/List'
import FormCategoriasControleInterno from '../Pages/Categorias/Form'
import ListControleInterno from '../Pages/Concursos/List'
import FormControleInterno from '../Pages/Concursos/Form'

export default [
	{
		path: 'servicos/controle-interno',
		component: Base,
		children: [
			{
				path: '',
				name: 'ListCategoriasControleInterno',
				component: ListCategoriasControleInterno,
				meta: {
					path: '/servicos/controle-interno',
					pai: 'Serviços',
					title: 'Admin - Controle Interno',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Controle Interno',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: 'novo',
				name: 'FormCategoriasControleInterno',
				component: FormCategoriasControleInterno,
				meta: {
					path: '/servicos/controle-interno',
					pai: 'Serviços',
					title: 'Admin - Controle Interno - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Controle Interno',
						class: '',
						active: false,
						url: '/servicos/controle-interno'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: 'editar/:id',
				name: 'FormCategoriasControleInternoEditar',
				component: FormCategoriasControleInterno,
				meta: {
					path: '/servicos/controle-interno',
					pai: 'Serviços',
					title: 'Admin - Controle Interno - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Controle Interno',
						class: '',
						active: false,
						url: '/servicos/controle-interno'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: ':id',
				name: 'ListControleInterno',
				component: ListControleInterno,
				meta: {
					path: '/servicos/controle-interno',
					pai: 'Serviços',
					title: 'Admin - Controle Interno - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Controle Interno',
						class: '',
						active: false,
						url: '/servicos/controle-interno'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: true,
						url: false,
						newClass: 'menu-selecionado'
					}],
					noCache: true
				},
			},

			{
				path: ':id/novo',
				name: 'FormControleInterno',
				component: FormControleInterno,
				meta: {
					path: '/servicos/controle-interno',
					pai: 'Serviços',
					title: 'Admin - Controle Interno - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Controle Interno',
						class: '',
						active: false,
						url: '/servicos/controle-interno'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			{
				path: ':id/editar/:cat',
				name: 'FormControleInternoEditar',
				component: FormControleInterno,
				meta: {
					path: '/servicos/controle-interno',
					pai: 'Serviços',
					title: 'Admin - Controle Interno - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Controle Interno',
						class: '',
						active: false,
						url: '/servicos/controle-interno'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
		]
	}
]